import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon as ShellsLoadingIcon} from 'shells/icon/svg/loading-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun, getServiceTypeIconForConnectionWidgets} from '../../calls/helpers';

type Props = {
    integrationType: ExternalServiceType;
};

export function InitialSyncEmptyState(props: Props) {
    const integrationName = getServiceNoun(props.integrationType);
    const IntegrationIcon = getServiceTypeIconForConnectionWidgets(props.integrationType);

    return (
        <div className='full-width flex items-center justify-center pt-64'>
            {/* @ts-expect-error */}
            <Stack spacing={24} alignCenter={true} isFullHeight={true}>
                <Stack spacing={8} alignItems='center' justifyContent='center'>
                    {/* @ts-expect-error */}
                    <Stack spacing={16} alignCenter={true} isHorizontal={true}>
                        <span>{IntegrationIcon}</span>
                        <Body isBold={true} color='dark' size='large'>
                            Syncing your {integrationName} calls
                        </Body>
                    </Stack>
                    <Body color='light' textAlign='center'>
                        This may take a few minutes. Your calls will appear here as they are synced.
                    </Body>
                    <LoadingIcon color={colors.placeholder} size={32} />
                </Stack>
            </Stack>
        </div>
    );
}

function LoadingIcon(props: {color: string; size: number}) {
    return <ShellsLoadingIcon color={props.color} size={props.size} />;
}
